'use strict';

import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export function shouldShowContactSelector(selection, fields = []) {
    return selection === 'user' && findFieldInFields(fields, 'email') && findFieldInFields(fields, 'phone');
}

export const findFieldInFields = (fields = [], fieldName) => fields.some(field => field.name === fieldName);
export const fieldDefaultMaxLength = field => field.field_type[0] === 'textarea' ? 140 : 40; // eslint-disable-line no-confusing-arrow

/*
 * Finds render index for <ContactSelector/>
 */
export function contactSelectorIndex(selection = 'both', fields = []) {
    if (selection === 'user') {
        for (const [i, field] of fields.entries()) {
            if (['email', 'phone'].includes(field.name)) {
                return i;
            }
        }
    }
}

/*
 * Returns a bool determining whether or not a field is required
 */
export function requiredContactMethods(field, method) {
    switch(field.name) {
        case 'email':
            if (method) {
                return ['email', 'both'].includes(method);
            }
        case 'phone':
            if (method) {
                return ['both', 'phone', 'user'].includes(method);
            }
        default:
            return field.is_required && field.is_required[0] === 'true';
    }
}

/*
 * Returns a bool determining whether or not a phone number is validated
 */
export function phoneNumberIsValid(acceptedCountryCodes, value) {
    for (let i = 0; i < acceptedCountryCodes.length; i++) {
        try {
            if (phoneUtil.isValidNumber(phoneUtil.parse(value, acceptedCountryCodes[i]))) {
                return true;
            }
        }

        catch (err) {
            return false;
        }
    }

    return false;
}



// WEBPACK FOOTER //
// ./components/contact_form/selectors.js